import React from 'react';
import Layout from '../../components/layout/layout';
import { WebPageSchema, BreadcrumbSchema } from '../../lib/utils/schema-utils';

export default function MappingRHPage() {
  return (
    <Layout
      title="Mapping RH - Test de compatibilité | recruteurs.io"
      description="Évaluez la compatibilité entre vos candidats et vos équipes grâce à notre outil de Mapping RH."
    >
      <WebPageSchema
        page={{
          title: "Mapping RH - Test de compatibilité",
          description: "Évaluez la compatibilité entre vos candidats et vos équipes.",
          url: "https://recruteurs.io/ressources/mapping-rh"
        }}
      />
      
      <BreadcrumbSchema
        items={[
          { name: "Accueil", url: "https://recruteurs.io" },
          { name: "Ressources", url: "https://recruteurs.io/ressources" },
          { name: "Mapping RH", url: "https://recruteurs.io/ressources/mapping-rh" }
        ]}
      />

      <div className="py-20">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
              Test de compatibilité RH
            </h1>
            <p className="text-xl text-neutral-600">
              Évaluez l'adéquation entre vos candidats et votre culture d'entreprise grâce à notre outil de mapping RH.
            </p>
          </div>

          <div id="hr-compatibility-test" className="w-full max-w-4xl mx-auto p-4">
            <iframe
              src="https://soft-platypus-aaf096.netlify.app/"
              width="100%"
              height="1200"
              frameBorder="0"
              style={{ border: 'none', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' }}
              title="Test de compatibilité RH"
              loading="lazy"
              allow="clipboard-write"
            />
          </div>
        </div>
      </div>
      <section className="max-w-4xl mx-auto px-4 md:px-0 mt-20 text-neutral-700 text-lg leading-relaxed">
  <h2 className="text-2xl font-bold mb-4 text-gradient">💡 L’IA dans le recrutement, ce n’est pas un gadget. C’est notre quotidien depuis 2017.</h2>

  <p className="mb-4">
    Chez <strong>Recruteurs.io</strong>, on ne suit pas les tendances. On les précède. 
    Depuis <strong>2017</strong>, on explore, on teste, on confronte l’<strong>intelligence artificielle</strong> à la réalité du terrain RH.
    Notre conviction est simple : l’IA ne remplace pas le recruteur, elle l’amplifie.
  </p>

  <p className="mb-4">
    C’est pourquoi on ne garde rien pour nous. Les outils qu’on utilise en interne, on les met à disposition de tous. 
    Gratuitement, quand c’est possible. Car si on veut vraiment faire évoluer les pratiques RH, on doit <strong>ouvrir les portes, pas les verrouiller</strong>.
  </p>

  <p className="mb-4">
    Le <strong>Mapping RH</strong> en est un parfait exemple. Un test simple, intuitif, qui vous permet d’évaluer l’<strong>adéquation culturelle</strong> entre un candidat et votre équipe. 
    Pas pour juger, mais pour <strong>comprendre, fluidifier, sécuriser</strong>.
  </p>

  <p className="mb-4">
    Ce que vous voyez ici, c’est la partie émergée de l’iceberg. Derrière, il y a une vraie mission : 
    rendre les recrutements plus humains, plus transparents, et plus performants.
  </p>

  <p>
    👉 En partageant nos outils, nos méthodes et notre vision, on espère que d’autres suivront. Parce que <strong>l’avenir du recrutement</strong>, 
    on ne le construira pas chacun dans son coin.
  </p>
</section>
    </Layout>
  );
}